import config from 'teacher-ui-client/config/environment'
import { join } from 'teacher-ui-client/utils/uri'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

const baseUrl = config.gravityCsvUrl

// import students url builders

export function buildSchoolStudentsCsvApiValidateUrl({
  schoolId,
  subscriptionType,
}: {
  schoolId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'schools', schoolId, subscriptionType, 'import-validation').href
}

export function buildTeacherStudentsCsvApiValidateUrl({
  teacherId,
  subscriptionType,
}: {
  teacherId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'teachers', teacherId, subscriptionType, 'import-validation').href
}

export function buildSchoolStudentsCsvApiValidateResultUrl({
  schoolId,
  subscriptionType,
}: {
  schoolId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'schools', schoolId, subscriptionType, 'import-validation-result').href
}

export function buildTeacherStudentsCsvApiValidateResultUrl({
  teacherId,
  subscriptionType,
}: {
  teacherId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'teachers', teacherId, subscriptionType, 'import-validation-result').href
}

export function buildSchoolStudentsCsvApiImportUrl({
  schoolId,
  subscriptionType,
}: {
  schoolId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'schools', schoolId, subscriptionType, 'import-schedules').href
}

export function buildTeacherStudentsCsvApiImportUrl({
  teacherId,
  subscriptionType,
}: {
  teacherId: string
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'teachers', teacherId, subscriptionType, 'import-schedules').href
}

// rollover import students url builders

export function buildRolloverStudentsCsvApiValidateUrl({ subscriptionType }: { subscriptionType: SubscriptionType }) {
  return join(baseUrl, 'rollovers', subscriptionType, 'validate').href
}

export function buildRolloverStudentsCsvApiValidateResultUrl({
  subscriptionType,
}: {
  subscriptionType: SubscriptionType
}) {
  return join(baseUrl, 'rollovers', subscriptionType, 'validation-result').href
}

export function buildRolloverStudentsCsvApiImportUrl({ subscriptionType }: { subscriptionType: SubscriptionType }) {
  return join(baseUrl, 'rollovers', subscriptionType, 'import').href
}
